
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/future-of-freight",
      function () {
        return require("private-next-pages/events/future-of-freight/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/future-of-freight"])
      });
    }
  